import {Flex, Icon, P, Title} from 'exsportia-components'
import {FC, useCallback} from 'react'
import {useNavigate} from 'react-router-dom'

import {Button} from '../../ui/components/button/button'
import {useLocale} from '../../utils/i18n'

export type EmptyListPropsType = {
  text?: string
  /** Optional second line for empty states that owe the user a reason, not just a headline. */
  description?: string
  buttonText?: string
  onClick?: (e?: Event) => void
  withoutBack?: boolean
}

export const EmptyList: FC<EmptyListPropsType> = ({
  text,
  description,
  onClick,
  buttonText,
  withoutBack = false,
}) => {
  const {l} = useLocale()
  const navigate = useNavigate()
  const onClickToUse = useCallback(() => (onClick ? onClick() : navigate(-1)), [navigate, onClick])
  const textToUse = text || l('empty_list')
  const buttonTextToUse = buttonText || l('back')
  return (
    <Flex
      flexDirection='column'
      alignItems='center'
    >
      <Icon
        icon='search'
        settings={{
          iconWidth: '200px',
          iconHeight: '200px',
          width: '200px',
          height: '200px',
          color: '#BFC1C7',
        }}
      />
      <Title
        styleType='h2'
        text={textToUse}
      />
      {Boolean(description) && (
        <P
          mt={'8px'}
          fontSize={'body'}
          textAlign={'center'}
          color={'text-secondary'}
        >
          {description}
        </P>
      )}
      {!withoutBack && (
        <Flex
          width='100%'
          mt='24px'
        >
          <Button onClick={onClickToUse}>{buttonTextToUse}</Button>
        </Flex>
      )}
    </Flex>
  )
}
